import { SubListLogic as Sublist } from './SubList.logic'

export default Sublist
